import './Homepage.css';
import './../styles/styles.css';
import meImage from './../assets/images/me-photo.jpg';
import { Component } from 'react';

import Slide from 'react-reveal/Pulse';
import Fade from 'react-reveal/Fade';
import Tilt from 'react-tilt'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFile } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import Header from './../Header/Header';

class Homepage extends Component {
    componentDidMount() { }

    render() {
        return <div className="Section" id="home">
            <Header></Header>
            <div className="hero-content" id="about">
                <div className="hero-text">
                    <Tilt options={{max:20}}>
                        <div className="Home-Hi-text">
                            <Slide left><h2 className="white">Hi there 👋</h2></Slide>
                            <Slide left><h1 className="white">I'm <span className="light">Rhydian</span></h1></Slide>
                        </div>
                    </Tilt>
                    <Fade bottom>
                        <p className="hero-bio white">
                            I'm a full-stack developer who builds custom commerce, supply-chain
                            and business software for B2B clients. I turn complex problems into
                            reliable, well-crafted tools that save time and cut out inefficiency —
                            and I love taking on something new. Got a project in mind? Let's talk —
                            reach me by email or on LinkedIn.
                        </p>
                        <div className="hero-buttons">
                            <a href={'https://github.com/rhydsjones011'} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithub} />&nbsp; GitHub</a>
                            <a href={'https://www.linkedin.com/in/rhydian-j'} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} />&nbsp; LinkedIn</a>
                            <a href={'mailto:rhydsjones011@gmail.com?subject=Hello from your website!'} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faEnvelope} />&nbsp; Email</a>
                            <a href="/cv"><FontAwesomeIcon icon={faFile} />&nbsp; CV</a>
                        </div>
                    </Fade>
                </div>
                <div className="hero-photo">
                    <Fade bottom>
                        <Tilt options={{max:25}}>
                            <img className="me-image" src={meImage} alt="Rhydian" />
                        </Tilt>
                    </Fade>
                </div>
            </div>
        </div>
  }
}

export default Homepage;
